import type { ConversationMode } from '@harness/shared';

// Workspace tabs, in order. Build Features is the build view; Create Tickets drafts Jira tickets with the
// Researcher (needs Jira); Create Wireframes draws HTML wireframes from tickets; Perform Analysis answers
// questions about the code. Everything except Build Features is read-only.
export const MODES: {
  mode: ConversationMode;
  label: string;
  path: string;
  newLabel: string;
  listLabel: string;
  placeholder: string;
  intro: string;
}[] = [
  {
    mode: 'ticket',
    label: 'Create Tickets',
    path: 'tickets',
    newLabel: 'New ticket',
    listLabel: 'Tickets',
    placeholder: 'Describe what the product needs: the problem, who it’s for, any must-haves…',
    intro:
      'Describe a feature or change in plain words. The Researcher reads the code, drafts a high-level ticket spec, suggests improvements and asks questions. Approve the spec, then create the ticket on the Jira board from the panel on the right.',
  },
  {
    mode: 'wireframe',
    label: 'Create Wireframes',
    path: 'wireframes',
    newLabel: 'New wireframe',
    listLabel: 'Wireframes',
    placeholder: 'Describe changes: “move the filters into a sidebar”, “add an empty state”, “make it a two-step form”…',
    intro:
      'Pick a Jira ticket in the panel on the right (or describe the screen here). The Wireframer reads the code and builds a low-fidelity wireframe you can see as it’s drawn. Then just type the changes you want.',
  },
  {
    mode: 'feature',
    label: 'Build Features',
    path: 'features',
    newLabel: 'New conversation',
    listLabel: 'Conversations',
    placeholder: '',
    intro: '',
  },
  {
    mode: 'analysis',
    label: 'Perform Analysis',
    path: 'analysis',
    newLabel: 'New question',
    listLabel: 'Questions',
    placeholder: 'Ask anything about the code: how does…, where is…, why does…',
    intro: 'Ask anything about this project’s code. The Analyst reads files and git history and answers with references. It never changes anything.',
  },
];

export const modeMeta = (m: ConversationMode) => MODES.find((x) => x.mode === m)!;
export const modeFromPath = (p?: string): ConversationMode | null => MODES.find((x) => x.path === p)?.mode ?? null;
export const modePath = (slug: string, m: ConversationMode) => `/p/${slug}/${modeMeta(m).path}`;
